import moment from "moment-timezone";

export async function isExistsThumbnail(thumbnailUrl) {
  try {
    const httpRes = await fetch(thumbnailUrl, { mode: "cors" });
    return Math.floor(httpRes.status / 100) === 2;
  } catch (e) {
    return false;
  }
}

export async function generateThumbnailPatchUp(thumbnailPatchUpList) {
  // 最初のtsファイルを使ってサムネイルの生成。

  thumbnailPatchUpList.forEach(async patchUpInfo => {
    const hour = patchUpInfo.hour;
    const targetDateYmdhUtc = patchUpInfo.ymdh;

    const targetHourOndemandUrl = this.hlsSrc
      .replace(/HLS.m3u8$/i, `${targetDateYmdhUtc}/OnDemand.m3u8`)
      .replace(
        /[0-9]{8}\/[0-9]{2}\/OnDemand.m3u8$/,
        `${targetDateYmdhUtc}/OnDemand.m3u8`
      );
    const thumbnailUrl = targetHourOndemandUrl.replace(
      /OnDemand.m3u8/i,
      "thumbnail.png"
    );
    const videoSrc = {
      withCredentials: false,
      type: "application/x-mpegurl",
      src: targetHourOndemandUrl,
    };

    let hiddenVideoPlayerObj = null;
    for (let i = 0; i < 10; i++) {
      hiddenVideoPlayerObj =
        this.$refs[`hiddenVideoPlayer${hour}`] &&
        this.$refs[`hiddenVideoPlayer${hour}`][0]
          ? this.$refs[`hiddenVideoPlayer${hour}`][0]
          : null;
      if (hiddenVideoPlayerObj) {
        break;
      }
      await this.sleep(1);
    }

    let hiddenPlayer = hiddenVideoPlayerObj.player;
    hiddenPlayer.reset();
    hiddenPlayer.src(videoSrc);

    hiddenPlayer.on("ready", async () => {
      let captureCount = 0;
      for (let i = 0; i < 20; i++) {
        await this.sleep(1);
        // 動画がロードされてからサムネイルを順次キャプチャ。
        const video = hiddenVideoPlayerObj.$el.querySelector("video");
        if (video && video.videoWidth > 0 && video.videoHeight > 0) {
          const canvas = document.createElement("canvas");
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          const context = canvas.getContext("2d");
          context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
          let binUrl = canvas.toDataURL("image/jpeg");
          this.$set(this.thumbnailUrlList, hour, {
            src: binUrl,
            path: thumbnailUrl,
          });
          captureCount++;
          if (captureCount >= 4) {
            break;
          }
        }
      }
    });
  });
}

export function convertGcsPath(apiUrl, movieType) {
  if (movieType === 9) {
    return apiUrl.replace(
      /^https:\/\/[^/]+\/v1\/admin\/enterprise\/cameras/,
      "https://storage.googleapis.com/aisea-movie-stream"
    );
  }
  return apiUrl.replace(
    /^https:\/\/[^/]+\/v1\/admin\/enterprise\/cameras/,
    process.env.VUE_APP_CLOUD_SOTRAGE_WEBCAM_URL.replace(/\/$/, "")
  );
}

export async function refreshThumbnailUrlList(self) {
  let thumbnailPatchUpList = [];
  if (self.hlsSrc) {
    self.thumbnailUrlList = [];
    const baseDateMoment = moment(self.targetDate).startOf("day");
    
    // Vue.$log.debug("### baseDateMoment", baseDateMoment.format('YYYYMMDD/HH'), baseDateMoment.utc().format('YYYYMMDD/HH'), self.hlsSrc );
    // https://storage.googleapis.com/aisea-webcam/06728e88b6c1eb24f3cc92b50e6a069fce556448c8e8b790e0cb889d0b2151cf/HLS.m3u8

    // https://api.aisea.dev/v1/admin/enterprise/cameras/30e2413e2e21bf527b697f2c0f09f3ed3e2d993b9967fe0445ffa80d9122bb39/hls.m3u8
    // https://storage.googleapis.com/aisea-webcam/30e2413e2e21bf527b697f2c0f09f3ed3e2d993b9967fe0445ffa80d9122bb39/20220527/05/thumbnail.png

    // GCS側のPATHを算出
    const hlsSrc = convertGcsPath(self.hlsSrc, self.camera.movieType);

    let thumbnailUrlList = [];
    for (let i = 0; i < 24; i++) {
      const targetDateYmdhUtc = moment(baseDateMoment)
        .utc()
        .add(i, "h")
        .format("YYYYMMDD/HH");
      const thumbnailUrl = hlsSrc
        .replace(/HLS.m3u8$/i, `${targetDateYmdhUtc}/thumbnail.png`)
        .replace(
          /[0-9]{8}\/[0-9]{2}\/OnDemand.m3u8$/,
          `${targetDateYmdhUtc}/thumbnail.png`
        );
      const isExists = await isExistsThumbnail(thumbnailUrl);

      if (isExists) {
        thumbnailUrlList.push({ src: thumbnailUrl, path: thumbnailUrl });
      } else {
        thumbnailUrlList.push({ src: self.noImageUrl, path: self.noImageUrl });
        
        // thumbnail.png が GCS上に存在しない場合、インデックス番号を覚えておき、tsファイルがあればそれを使って後から差し込む
        thumbnailPatchUpList.push({ hour: i, ymdh: targetDateYmdhUtc });
      }
    }
    await generateThumbnailPatchUp(thumbnailPatchUpList);
    self.thumbnailUrlList = thumbnailUrlList;
  }
}
